import { Component } from "@angular/core";

@Component({
  selector: "app-data-view",
  templateUrl: "./data-view.component.html",
  styleUrl: "./data-view.component.css",
  standalone: false,
})
export class DataViewComponent {}
